import { Tooltip, Fade } from '@mui/material'
import type { Organization } from '../../../types'
import type { ReactElement } from 'react'

type MapTooltipProps = {
  organization: Organization
  children: ReactElement
}

const MapTooltip = ({ organization, children }: MapTooltipProps) => {
  const isTouchDevice =
    typeof window !== 'undefined' &&
    window.matchMedia('(hover: none) and (pointer: coarse)').matches

  if (isTouchDevice) {
    return children
  }

  const typeLabel = organization.initCommTask ? 'INITIATIVE' : 'MOVEMENT ORG'

  const content = (
    <div className="p-3 bg-white">
      <p
        className="font-decimal text-green leading-tight"
        style={{ fontSize: 20, fontWeight: 700 }}
      >
        {organization.org_name}
      </p>
      <p
        className="font-decimal uppercase text-ink leading-tight mt-0.5"
        style={{ fontSize: 16 }}
      >
        <span style={{ fontWeight: 700 }}>{typeLabel}</span>
        <span style={{ fontWeight: 400 }}>
          <span className="mx-1.5">|</span>
          {organization.city}, {organization.state}
        </span>
      </p>
      <p className="font-decimal text-ink mt-3" style={{ fontSize: 14, fontWeight: 600 }}>
        click to read more →
      </p>
    </div>
  )

  return (
    <Tooltip
      title={content}
      placement="top"
      arrow
      enterDelay={0}
      leaveDelay={0}
      disableTouchListener
      TransitionComponent={Fade}
      TransitionProps={{ timeout: 0 }}
      slotProps={{
        tooltip: {
          sx: {
            bgcolor: 'transparent',
            p: 0,
            maxWidth: 350,
            boxShadow: '0 4px 25px 0 rgba(0,0,0,0.25)',
          },
        },
        popper: {
          sx: {
            maxWidth: 'none',
            bgcolor: 'transparent',
            p: 0,
            '&:after': { display: 'none' },
          },
        },
        arrow: { sx: { color: 'primary.main' } },
      }}
    >
      {children}
    </Tooltip>
  )
}

export default MapTooltip
